<div class="gcp_legend">
  <svg-icon [src]="sphereIcon"></svg-icon>
  <span>Ground Control Point</span>
</div>
